module.exports = __webpack_public_path__ + "static/media/nave.7ceec4b3.bin";